import React from "react";

const UpcomingAppointments = () => {
  const upcomingTask = [
    {
      id: 1234,
      task2: "Miller, John ",
      taskContentUp: "Immunization ",
      time: "09:00 AM",
      min: "30 Min left",
    },
    {
      id: 1334,
      task2: "Smith, Sally",
      taskContentUp: "Covid Test",
      time: "10:00 AM",
      min: "1 hr left",
    },
    {
      id: 1434,
      task2: "Eagan, Helena",
      taskContentUp: "Immunization ",
      time: "10:30 AM",
      min: "1.5 hrs Left",
    },
    {
      id: 1534,
      task2: "Scout, Mark",
      taskContentUp: "Flu Test ",
      time: "11:00 AM",
      min: "2 hrs Left",
    },
    {
      id: 1634,
      task2: "Garner, Doug",
      taskContentUp: "Immunization",
      time: "11:30 AM",
      min: "2.5 hrs Left",
    },
    {
      id: 1234,
      task2: "Miller, John ",
      taskContentUp: "Immunization ",
      time: "09:00 AM",
      min: "30 Min left",
    },
    {
      id: 1334,
      task2: "Smith, Sally",
      taskContentUp: "Covid Test",
      time: "10:00 AM",
      min: "1 hr left",
    },
    {
      id: 1434,
      task2: "Eagan, Helena",
      taskContentUp: "Immunization ",
      time: "10:30 AM",
      min: "1.5 hrs Left",
    },
    {
      id: 1534,
      task2: "Scout, Mark",
      taskContentUp: "Flu Test ",
      time: "11:00 AM",
      min: "2 hrs Left",
    },
    {
      id: 1634,
      task2: "Garner, Doug",
      taskContentUp: "Immunization",
      time: "11:30 AM",
      min: "2.5 hrs Left",
    },
    {
      id: 1234,
      task2: "Miller, John ",
      taskContentUp: "Immunization ",
      time: "09:00 AM",
      min: "30 Min left",
    },
    {
      id: 1334,
      task2: "Smith, Sally",
      taskContentUp: "Covid Test",
      time: "10:00 AM",
      min: "1 hr left",
    },
    {
      id: 1434,
      task2: "Eagan, Helena",
      taskContentUp: "Immunization ",
      time: "10:30 AM",
      min: "1.5 hrs Left",
    },
    {
      id: 1534,
      task2: "Scout, Mark",
      taskContentUp: "Flu Test ",
      time: "11:00 AM",
      min: "2 hrs Left",
    },
    {
      id: 1634,
      task2: "Garner, Doug",
      taskContentUp: "Immunization",
      time: "11:30 AM",
      min: "2.5 hrs Left",
    },
    {
      id: 1234,
      task2: "Miller, John ",
      taskContentUp: "Immunization ",
      time: "09:00 AM",
      min: "30 Min left",
    },
    {
      id: 1334,
      task2: "Smith, Sally",
      taskContentUp: "Covid Test",
      time: "10:00 AM",
      min: "1 hr left",
    },
    {
      id: 1434,
      task2: "Eagan, Helena",
      taskContentUp: "Immunization ",
      time: "10:30 AM",
      min: "1.5 hrs Left",
    },
    {
      id: 1534,
      task2: "Scout, Mark",
      taskContentUp: "Flu Test ",
      time: "11:00 AM",
      min: "2 hrs Left",
    },
    {
      id: 1634,
      task2: "Garner, Doug",
      taskContentUp: "Immunization",
      time: "11:30 AM",
      min: "2.5 hrs Left",
    },
  ];
  return (
    <div style={{ width: "42vw", padding: "16px", cursor: "pinter" }}>
         {upcomingTask.map((up) => (
            <div key={up.id} className="d-flex justify-content-between mb-2">
              <div>
                <h4 className="dash-name">{up.task2} </h4>
                <h5 className="dash-cont">{up.taskContentUp}</h5>
              </div>

              <div className="d-flex flex-column align-items-start" style={{width:"5vw"}}>
                <h4 className="time">{up.time} </h4>
                <h5 className="min">{up.min}</h5>
              </div>
            </div>
          ))}
    
   
    </div>
  );
};

export default UpcomingAppointments;
